import { useState, useRef, useEffect } from "react";
import { MessageSquare, X, Send, Bot } from "lucide-react";
import { api } from "../lib/api";
import { COMPANY } from "../mock";

const sid = () => {
  let s = localStorage.getItem("dd_chat_sid");
  if (!s) {
    s =
      "sess-" +
      Date.now().toString(36) +
      Math.random().toString(36).slice(2, 8);
    localStorage.setItem("dd_chat_sid", s);
  }
  return s;
};

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([
    {
      role: "assistant",
      text: "Halo! Saya asisten virtual PT Delapan Delapan Industri 🚛. Ada yang bisa saya bantu seputar layanan karoseri kami?",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs, open]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setInput("");
    setMsgs((m) => [...m, { role: "user", text }]);
    setLoading(true);
    try {
      const { data } = await api.post("/chat", { session_id: sid(), message: text });
      setMsgs((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (e) {
      const limit = e?.response?.status === 429;
      setMsgs((m) => [
        ...m,
        {
          role: "assistant",
          text: limit
            ? "Mohon tunggu sebentar ya, pesan terlalu cepat berturut-turut. 🙏"
            : "Maaf, terjadi kendala. Silakan hubungi kami via WhatsApp.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-3">
        <a
          href={`https://wa.me/${COMPANY.phoneRaw}`}
          target="_blank"
          rel="noreferrer"
          className="card-dark rounded-full pl-2 pr-4 py-2 flex items-center gap-2.5 text-sm hover:border-[#25D366] shadow-lg"
        >
          <span className="w-9 h-9 rounded-full bg-[#25D366] flex items-center justify-center text-white font-bold text-lg">
            W
          </span>
          <span className="text-white/90 leading-tight text-left">
            Chat Admin
            <br />
            <span className="text-[10px] text-green-400">Online · Klik untuk chat</span>
          </span>
        </a>
        {!open && (
          <button
            onClick={() => setOpen(true)}
            className="w-14 h-14 rounded-full flex items-center justify-center bg-gradient-to-r from-[#2f7bff] to-[#1f5fe0] shadow-lg shadow-[#2f7bff]/40 hover:scale-105 transition-transform"
            aria-label="Buka chat"
          >
            <MessageSquare className="w-6 h-6 text-white" />
          </button>
        )}
      </div>

      {open && (
        <div className="fixed bottom-5 right-5 z-[70] w-[92vw] max-w-sm h-[70vh] max-h-[560px] card-dark rounded-2xl flex flex-col overflow-hidden shadow-2xl">
          <div className="flex items-center justify-between p-4 border-b border-[#4facfe]/15 bg-[#0a152b]">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-[#2f7bff] to-[#1f5fe0] flex items-center justify-center">
                <Bot className="w-5 h-5 text-white" />
              </div>
              <div>
                <div className="font-display font-bold text-white text-sm">Asisten 88</div>
                <div className="text-[10px] text-green-400">● Online 24/7</div>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/60 hover:text-white" aria-label="Tutup chat">
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            {msgs.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                <div
                  className={`max-w-[80%] px-3.5 py-2.5 rounded-2xl text-sm ${
                    m.role === "user"
                      ? "bg-gradient-to-r from-[#2f7bff] to-[#1f5fe0] text-white rounded-br-sm"
                      : "bg-white/5 text-white/90 rounded-bl-sm border border-white/10"
                  }`}
                >
                  {m.text}
                </div>
              </div>
            ))}
            {loading && <div className="text-white/50 text-sm px-3">Asisten 88 sedang mengetik…</div>}
            <div ref={endRef} />
          </div>
          <div className="p-3 border-t border-[#4facfe]/15 flex gap-2">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()}
              placeholder="Tulis pesan…"
              className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 text-sm text-white outline-none focus:border-[#4facfe]"
            />
            <button
              onClick={send}
              className="bg-gradient-to-r from-[#2f7bff] to-[#1f5fe0] w-11 h-11 rounded-full flex items-center justify-center shrink-0"
              aria-label="Kirim"
            >
              <Send className="w-4 h-4 text-white" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};
